import { render } from "./oauth-login.vue?vue&type=template&id=962cd1b0&scoped=true"
import script from "./oauth-login.vue?vue&type=script&lang=js"
export * from "./oauth-login.vue?vue&type=script&lang=js"

import "./oauth-login.vue?vue&type=style&index=0&id=962cd1b0&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-962cd1b0"]])

export default __exports__